module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/board/bg-seamless-653.jpg"+" 653w",
        images: [{path: __webpack_public_path__ + "assets/images/board/bg-seamless-653.jpg",width: 653,height: 560}],
        src: __webpack_public_path__ + "assets/images/board/bg-seamless-653.jpg",
        toString: function(){return __webpack_public_path__ + "assets/images/board/bg-seamless-653.jpg"},
        
        width: 653,
        height: 560
      }